/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectUsageDTO } from './ProjectUsageDTO';
import {
    ProjectUsageDTOFromJSON,
    ProjectUsageDTOFromJSONTyped,
    ProjectUsageDTOToJSON,
} from './ProjectUsageDTO';

/**
 * 
 * @export
 * @interface ProjectUsageListDTO
 */
export interface ProjectUsageListDTO {
    /**
     * 
     * @type {Array<ProjectUsageDTO>}
     * @memberof ProjectUsageListDTO
     */
    projects: Array<ProjectUsageDTO>;
}

/**
 * Check if a given object implements the ProjectUsageListDTO interface.
 */
export function instanceOfProjectUsageListDTO(value: object): value is ProjectUsageListDTO {
    if (!('projects' in value) || value['projects'] === undefined) return false;
    return true;
}

export function ProjectUsageListDTOFromJSON(json: any): ProjectUsageListDTO {
    return ProjectUsageListDTOFromJSONTyped(json, false);
}

export function ProjectUsageListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUsageListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'projects': ((json['projects'] as Array<any>).map(ProjectUsageDTOFromJSON)),
    };
}

export function ProjectUsageListDTOToJSON(value?: ProjectUsageListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projects': ((value['projects'] as Array<any>).map(ProjectUsageDTOToJSON)),
    };
}

